import { render } from "./Transparencia.vue?vue&type=template&id=85249472&scoped=true"
const script = {}

import "./Transparencia.vue?vue&type=style&index=0&id=85249472&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85249472"]])

export default __exports__